module.exports = ".padding-top{\r\n    padding-top: 45px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-acquisition/landacquisition-grid/landacquisition-grid.component.css
// module id = ./src/app/landprocurement/land-acquisition/landacquisition-grid/landacquisition-grid.component.css
// module chunks = main